import { SharedExtractControl, UserOrderControl } from 'models/table/ITableExtract';
import React from 'react';
import {Checkbox} from "@material-ui/core";
import styles from "../TableResumeView.module.scss";
import {ButtonNumber} from "../../../../components/buttons/buttonNumber/ButtonNumber";
import {useTablePayment} from "../../../../context/tablePayment/TablePaymentContext";
import { moneyMaskNumber } from 'utils/mask/money';

interface CheckboxRowsProps {
    index?: number;
    extract: SharedExtractControl;
    onToggleUser?: (extract: SharedExtractControl, checked: boolean) => void;
    onToggleOrder: (order: UserOrderControl, extract: SharedExtractControl, checked: boolean) => void
    onHandleQuantityChange: (order: UserOrderControl, newValue: number, extract: SharedExtractControl) => void
}

interface OrderRowProps extends CheckboxRowsProps {
    order: UserOrderControl;
}

export const TableResumeUserRow = React.memo<CheckboxRowsProps>(({ index, extract, onToggleUser, onToggleOrder, onHandleQuantityChange }) => {
    const allChildrenChecked = (extract.userOrders || []).every(o => o.checked);

    return (
        <div className={styles.details}>
            <div className={styles.userResume}>
                <Checkbox
                    checked={allChildrenChecked}
                    onChange={(e) => onToggleUser?.(extract, e.target.checked)}
                    color="primary"
                />
                <span className={styles.productName}>{extract.userData?.name}</span>
                <span className={styles.productPrice}>
          {extract.userData?.remainingBalance}
        </span>
            </div>

            {(extract.userOrders || []).map((order, i) => (
                <TableResumeOrderRow
                    key={i}
                    order={order}
                    extract={extract}
                    onToggleOrder={onToggleOrder}
                    onHandleQuantityChange={onHandleQuantityChange} />
            ))}
        </div>
    );
});

const TableResumeOrderRow = React.memo<OrderRowProps>(({extract, order, onToggleOrder, onHandleQuantityChange}) => {
    const {getOrderRemainingBalance} = useTablePayment();
    return (
        <>
            <div className={styles.orderResume}>
                <div className={styles.itemResume}>
                    <Checkbox
                        checked={order.checked}
                        onChange={(e) => onToggleOrder(order, extract, e.target.checked)}
                        color="secondary"
                    />
                    <span className={styles.productName}>{order.productName}</span>
                    <div className={styles.quantityButton}>
                        <ButtonNumber
                            value={order.quantity}
                            disabled={!order.checked}
                            min={1}
                            max={order.totalQuantity}
                            onChange={(newValue) => onHandleQuantityChange(order, newValue, extract)}
                        />
                    </div>
                    <span className={styles.productPrice}>
                        {moneyMaskNumber(getOrderRemainingBalance(order))}
                    </span>
                </div>
            </div>
        </>
    );
});
